import { useConfigurableAction } from '@shesha-io/reactjs';
import React from 'react';

export interface IMapActionsProps {
  drawRef: React.MutableRefObject<MapboxDraw | null>;
  saveBtnRef: React.MutableRefObject<HTMLButtonElement | null>;
  deleteBtnRef: React.MutableRefObject<HTMLButtonElement | null>;
}

export enum MapActionOwners {
  Map = 'shesha.map',
}

export const useMapActions = ({ drawRef, saveBtnRef, deleteBtnRef }: IMapActionsProps) => {
  const actionDependencies = [drawRef];

  useConfigurableAction(
    {
      name: 'Start Drawing Polygon',
      owner: 'Map',
      ownerUid: MapActionOwners.Map,
      hasArguments: false,
      executer: () => {
        if (drawRef.current) {
          drawRef.current.changeMode('draw_polygon');
        }
        return Promise.resolve();
      },
    },
    actionDependencies,
  );

  useConfigurableAction(
    {
      name: 'Start Drawing Circle',
      owner: 'Map',
      ownerUid: MapActionOwners.Map,
      hasArguments: false,
      executer: () => {
        if (drawRef.current) {
          drawRef.current.changeMode('draw_circle');
        }
        return Promise.resolve();
      },
    },
    actionDependencies,
  );

  useConfigurableAction(
    {
      name: 'Cancel Drawing',
      owner: 'Map',
      ownerUid: MapActionOwners.Map,
      hasArguments: false,
      executer: () => {
        if (drawRef.current) {
          drawRef.current.changeMode('simple_select');
        }
        return Promise.resolve();
      },
    },
    actionDependencies,
  );

  // useConfigurableAction(
  //   {
  //     name: 'Get Map Mode',
  //     owner: 'Map',
  //     ownerUid: MapActionOwners.Map,
  //     hasArguments: false,
  //     executer: () => {
  //       if (drawRef.current) {
  //         return Promise.resolve(drawRef.current.getMode());
  //       }
  //       return Promise.resolve({});
  //     },
  //   },
  //   actionDependencies,
  // );

  useConfigurableAction({
    name: 'Delete Selected Polygon',
    owner: 'Map',
    ownerUid: MapActionOwners.Map,
    hasArguments: false,
    executer: () => {
      if (deleteBtnRef.current) {
        try {
          deleteBtnRef.current.click();
        } catch (e) {
          return Promise.reject(e);
        }
      }
      return Promise.resolve();
    },
  });

  useConfigurableAction({
    name: 'Save Data',
    owner: 'Map',
    ownerUid: MapActionOwners.Map,
    hasArguments: false,
    executer: () => {
      if (saveBtnRef.current) {
        try {
          saveBtnRef.current.click();
        } catch (e) {
          return Promise.reject(e);
        }
      }
      return Promise.resolve();
    },
  });

  useConfigurableAction({
    name: 'Clear Polygons',
    owner: 'Map',
    ownerUid: MapActionOwners.Map,
    hasArguments: false,
    executer: () => {
      if (drawRef.current) {
        drawRef.current.deleteAll();
      }
      return Promise.resolve();
    },
  }, actionDependencies);

  useConfigurableAction(
    {
      name: 'Reload Map',
      owner: 'Map',
      ownerUid: MapActionOwners.Map,
      hasArguments: false,
      executer: async () => {
        // Perform hard reset (remount)
        if (typeof (window as any).hardResetMap === 'function') {
          (window as any).hardResetMap();
        }
        // Optionally, clear polygons and reload boundaries after remount
        if (drawRef.current) {
          drawRef.current.deleteAll();
        }
        if (typeof (window as any).getBoundariesAsync === 'function') {
          const newBoundaries = await (window as any).getBoundariesAsync();
          if (typeof (window as any).redrawBoundaries === 'function') {
            (window as any).redrawBoundaries(newBoundaries);
          }
        }
        return Promise.resolve();
      },
    },
    actionDependencies,
  );
};
  